import { Modal } from "antd";
import { useDispatch, useSelector } from "react-redux";
import {
    updateDailyBudgetModalData,
    updateDailyBudgetModalDisplay,
} from "@features/modalSlice";
import { useEffect, useState } from "react";
import { showToast } from "@/ts/modals";
import {
    internationalizeNumericValue,
    parseInternationalizedValue,
    updateCampaigns,
    updateRequiredDailyBudget,
} from "@/ts/utils";
import $ from "jquery";
import { Campaign, IDailyBudgetModalData, State } from "@/ts/common-types";
import { setUpdateGridData } from "@/ts/filters";

interface IDailyBudgetModalDisplay {
    dailyBudgetModalDisplay: {
        value: boolean;
    };
}

import { AiOutlineClose } from "react-icons/ai";
import useGetModulesData from "@/hooks/useGetModulesData";

const UpdateRequiredDailyBudgetModal = () => {
    const dispatch = useDispatch();
    const dailyBudgetModalDisplay = useSelector(
        (state: IDailyBudgetModalDisplay) => state.dailyBudgetModalDisplay.value
    );
    const dailyBudgetModalData = useSelector(
        (state: IDailyBudgetModalData) => state.dailyBudgetModalData.value
    );
    const [inputValue, setInputValue] = useState<string>("");
    const isDailyBudgetChangeOnPlatform = useGetModulesData({
        type: "grid-params",
    });

    useEffect(() => {
        const value =
            +dailyBudgetModalData.daily_budget ||
            +dailyBudgetModalData.required_daily_spend;
        value &&
            setInputValue(
                String(internationalizeNumericValue(value.toFixed(2)))
            );
    }, [dailyBudgetModalData, dailyBudgetModalDisplay]);

    const handleClose = () => {
        dispatch(updateDailyBudgetModalDisplay(false));
        dispatch(updateDailyBudgetModalData({} as Campaign));
        setInputValue("");
    };

    const onApplyClickHandler = async () => {
        try {
            const parsedInputValue = +parseInternationalizedValue(inputValue);
            if (
                parsedInputValue < 1 ||
                parsedInputValue > (dailyBudgetModalData.budget as number) ||
                Number.isNaN(parsedInputValue)
            ) {
                showToast(
                    "danger",
                    `Daily Budget should be between 1 and ${dailyBudgetModalData.budget}`
                );
            } else {
                const campaigns = {
                    campaignId: dailyBudgetModalData.sys_campaign_id.toString(),
                    ...(isDailyBudgetChangeOnPlatform
                        ? {
                              state: dailyBudgetModalData.state,
                              attribute: ["daily_budget"],
                              daily_budget: +parsedInputValue,
                          }
                        : {
                              dailyBudget: +parsedInputValue,
                          }),
                };

                const response = isDailyBudgetChangeOnPlatform
                    ? await updateCampaigns([
                          campaigns as {
                              state: State;
                              attribute: string[];
                              daily_budget: number;
                              campaignId: string;
                          },
                      ])
                    : await updateRequiredDailyBudget(
                          campaigns as {
                              campaignId: string;
                              dailyBudget: number;
                          }
                      );

                if (!response.status) {
                    throw new Error(response.message);
                }

                setUpdateGridData({
                    params: {
                        data: dailyBudgetModalData,
                    },
                    value: parsedInputValue,
                    isReduxState: true,
                    modalParamToChange: "daily_budget",
                });

                if (!response.status) {
                    throw new Error(response.message);
                }
                $(
                    `#dailyBudgetModalBtn_${dailyBudgetModalData.sys_campaign_id}`
                ).css("color", "#5cb85c");
                showToast("success", response.message);
                dispatch(updateDailyBudgetModalDisplay(false));
            }
        } catch (err) {
            setInputValue(
                (dailyBudgetModalData.required_daily_spend as number).toFixed(2)
            );
            const resErrMsg = (err as Error).message;
            const errorMessage =
                ` Error While Updating Daily Budget for ${dailyBudgetModalData.campaign_name}` +
                `${resErrMsg && ": " + resErrMsg}`;
            showToast("danger", errorMessage);
        }
    };

    const onRemoveClickHandler = async () => {
        try {
            const campaigns = {
                campaignId: dailyBudgetModalData.sys_campaign_id.toString(),
                ...(isDailyBudgetChangeOnPlatform
                    ? {
                          state: dailyBudgetModalData.state,
                          attribute: ["daily_budget"],
                          daily_budget: 0,
                      }
                    : {
                          dailyBudget: 0,
                      }),
            };

            const response = isDailyBudgetChangeOnPlatform
                ? await updateCampaigns([
                      campaigns as {
                          state: State;
                          attribute: string[];
                          daily_budget: number;
                          campaignId: string;
                      },
                  ])
                : await updateRequiredDailyBudget(
                      campaigns as {
                          campaignId: string;
                          dailyBudget: number;
                      }
                  );
            setUpdateGridData({
                params: {
                    data: dailyBudgetModalData,
                },
                value: 0,
                isReduxState: true,
                modalParamToChange: "daily_budget",
            });
            if (!response.status) {
                throw new Error(response.message);
            }
            setInputValue(
                (dailyBudgetModalData.required_daily_spend as number).toFixed(2)
            );
            $(
                `#dailyBudgetModalBtn_${dailyBudgetModalData.sys_campaign_id}`
            ).css("color", "#B2B2B2");
            showToast("success", response.message);
            dispatch(updateDailyBudgetModalDisplay(false));
        } catch (err) {
            const resErrMsg = (err as Error).message;
            const errorMessage =
                ` Error While Updating Daily Budget for ${dailyBudgetModalData.campaign_name}` +
                `${resErrMsg && ": " + resErrMsg}`;
            showToast("danger", errorMessage);
        }
    };

    return (
        <>
            {dailyBudgetModalDisplay && (
                <Modal
                    title={
                        <div
                            className="d-flex align-items-center pb-3"
                            style={{ fontSize: "1.5rem", fontWeight: "600" }}
                        >
                            Daily Budget
                        </div>
                    }
                    open={dailyBudgetModalDisplay}
                    onCancel={handleClose}
                    footer={null}
                    closeIcon={<AiOutlineClose style={{ fontSize: "40px" }} />}
                    centered
                    width={"35%"}
                    styles={{
                        body: {
                            height: "23.5vh",
                        },
                    }}
                >
                    <div style={{ padding: "1.5rem 1.5rem" }}>
                        <div
                            className="input-group-sm"
                            style={{ marginBottom: "2rem" }}
                        >
                            <input
                                className="form-control"
                                id="updateDailyBudgetInput"
                                type="text"
                                style={{ width: "250px", height: "3rem" }}
                                onFocus={() =>
                                    setInputValue(
                                        String(
                                            parseInternationalizedValue(
                                                inputValue
                                            )
                                        )
                                    )
                                }
                                onBlur={() =>
                                    setInputValue(
                                        String(
                                            internationalizeNumericValue(
                                                inputValue
                                            )
                                        )
                                    )
                                }
                                value={inputValue}
                                onChange={(e) => {
                                    setInputValue(e.target.value);
                                }}
                            />
                        </div>
                        <button
                            className="btn btn-primary"
                            id="updateDailyBudgetBtn"
                            type="button"
                            style={{ fontSize: "1rem", padding: "0.7rem 2rem" }}
                            onClick={onApplyClickHandler}
                        >
                            Apply
                        </button>
                        {dailyBudgetModalData.daily_budget ? (
                            <button
                                className="btn btn-danger"
                                id="removeDailyBudgetBtn"
                                type="button"
                                style={{
                                    fontSize: "1rem",
                                    padding: "0.7rem 2rem",
                                    marginLeft: "15px",
                                }}
                                onClick={onRemoveClickHandler}
                            >
                                Remove
                            </button>
                        ) : null}
                    </div>
                </Modal>
            )}
        </>
    );
};

export default UpdateRequiredDailyBudgetModal;
